import { CapoPlugin } from "/home/ec2-user/liberty_code/LIBERTY-KAKUSAN-FRONTEND/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];